import React from 'react';
import './Footer.css';

const Footer = () => {

  const currentYear = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <p className="footer-copyright">© {currentYear} Miden Hub. All rights reserved.</p>
      <div className="footer-social">
        <a 
          href="https://twitter.com/0xMiden_hub" 
          className="footer-social-link"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <span className="sr-only">Twitter</span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="currentColor" 
            className="footer-icon"
            aria-hidden="true"
          >
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
          </svg>
        </a>
      </div>
    </footer>
  );
};

export default Footer;